module.exports = {"submit":"Login","error":{"responseTypes":{"forbidden":"The user name or password is not valid. Please revise the data."}}}